
import { Profile } from "./types";
import { createLogger } from "../utils/loggingUtils";

const logger = createLogger('profileCache');

// Cache for profiles to reduce duplicate requests
const profileCache = new Map<string, { data: Profile, timestamp: number }>();
const CACHE_TTL = 60 * 1000; // 1 minute

export const getProfileFromCache = (userId: string): Profile | null => {
  const now = Date.now();
  const cached = profileCache.get(userId);
  
  if (cached && now - cached.timestamp < CACHE_TTL) {
    logger.info("Using cached profile for user:", userId);
    return cached.data;
  }
  
  return null;
};

export const updateProfileCache = (userId: string, profile: Profile): void => {
  profileCache.set(userId, { data: profile, timestamp: Date.now() });
  logger.info("Updated profile cache for user:", userId);
};

// Clear profile cache for a specific user or all users
export const clearProfileCache = (userId?: string) => {
  if (userId) {
    profileCache.delete(userId);
    logger.info(`Cleared profile cache for user: ${userId}`);
  } else {
    profileCache.clear();
    logger.info('Cleared all profile caches');
  }
};
